import React from 'react';

export default function CEODashboard() {
  const kpiData = [
    { title: 'Total Revenue', value: '₹2.45 Cr', change: '+12.5%', trend: 'up' },
    { title: 'Active Customers', value: '1,247', change: '+8.3%', trend: 'up' },
    { title: 'Monthly Orders', value: '342', change: '+15.2%', trend: 'up' },
    { title: 'Profit Margin', value: '23.8%', change: '+2.1%', trend: 'up' },
  ];

  const branchPerformance = [
    { branch: 'Main Store', revenue: '₹85.2L', orders: 156, growth: '+18%' },
    { branch: 'Mall Branch', revenue: '₹72.8L', orders: 134, growth: '+12%' },
    { branch: 'City Center', revenue: '₹68.5L', orders: 128, growth: '+9%' },
    { branch: 'Heritage Store', revenue: '₹45.3L', orders: 89, growth: '+15%' },
  ];

  return (
    <div className="p-6 space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-primary">CEO Executive Dashboard</h1>
        <div className="flex gap-3">
          <button className="bg-primary text-white px-4 py-2 rounded-lg hover:bg-primary/90 transition-colors whitespace-nowrap cursor-pointer">
            <i className="ri-download-line mr-2"></i>
            Export Report
          </button>
          <button className="border border-primary text-primary px-4 py-2 rounded-lg hover:bg-primary/5 transition-colors whitespace-nowrap cursor-pointer">
            <i className="ri-settings-line mr-2"></i>
            Settings
          </button>
        </div>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {kpiData.map((kpi, index) => (
          <div key={index} className="bg-white p-6 rounded-lg shadow-sm border">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">{kpi.title}</p>
                <p className="text-2xl font-bold text-gray-900 mt-1">{kpi.value}</p>
                <div className="flex items-center mt-2">
                  <i className={`ri-arrow-${kpi.trend === 'up' ? 'up' : 'down'}-line text-${kpi.trend === 'up' ? 'green' : 'red'}-600 mr-1`}></i>
                  <span className={`text-sm font-medium text-${kpi.trend === 'up' ? 'green' : 'red'}-600`}>
                    {kpi.change}
                  </span>
                </div>
              </div>
              <div className="p-3 bg-primary/10 rounded-lg">
                <i className="ri-line-chart-line text-primary text-xl"></i>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Branch Performance */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h2 className="text-xl font-semibold text-primary mb-4">Branch Performance</h2>
          <div className="space-y-4">
            {branchPerformance.map((branch, index) => (
              <div key={index} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div>
                  <h3 className="font-semibold text-gray-900">{branch.branch}</h3>
                  <p className="text-sm text-gray-600">{branch.orders} orders</p>
                </div>
                <div className="text-right">
                  <p className="font-bold text-gray-900">{branch.revenue}</p>
                  <p className="text-sm text-green-600">{branch.growth}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h2 className="text-xl font-semibold text-primary mb-4">Strategic Metrics</h2>
          <div className="space-y-4">
            <div className="flex justify-between items-center p-3 border-b">
              <span className="text-gray-600">Customer Acquisition Cost</span>
              <span className="font-semibold">₹2,450</span>
            </div>
            <div className="flex justify-between items-center p-3 border-b">
              <span className="text-gray-600">Customer Lifetime Value</span>
              <span className="font-semibold">₹1,25,000</span>
            </div>
            <div className="flex justify-between items-center p-3 border-b">
              <span className="text-gray-600">Inventory Turnover</span>
              <span className="font-semibold">4.2x</span>
            </div>
            <div className="flex justify-between items-center p-3">
              <span className="text-gray-600">Market Share</span>
              <span className="font-semibold">12.8%</span>
            </div>
          </div>
        </div>
      </div>

      {/* Pending Approvals */}
      <div className="bg-white p-6 rounded-lg shadow-sm border">
        <h2 className="text-xl font-semibold text-primary mb-4">Pending CEO Approvals</h2>
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left font-medium text-gray-900">Type</th>
                <th className="px-4 py-3 text-left font-medium text-gray-900">Description</th>
                <th className="px-4 py-3 text-left font-medium text-gray-900">Amount</th>
                <th className="px-4 py-3 text-left font-medium text-gray-900">Requested By</th>
                <th className="px-4 py-3 text-left font-medium text-gray-900">Date</th>
                <th className="px-4 py-3 text-left font-medium text-gray-900">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-t">
                <td className="px-4 py-3">
                  <span className="px-2 py-1 bg-yellow-100 text-yellow-800 rounded-full text-xs">Discount</span>
                </td>
                <td className="px-4 py-3">Bulk order discount - 25% off</td>
                <td className="px-4 py-3 font-medium">₹2,50,000</td>
                <td className="px-4 py-3">Operations Head</td>
                <td className="px-4 py-3">2024-01-20</td>
                <td className="px-4 py-3">
                  <div className="flex gap-2">
                    <button className="text-green-600 hover:text-green-800 cursor-pointer">
                      <i className="ri-check-line"></i>
                    </button>
                    <button className="text-red-600 hover:text-red-800 cursor-pointer">
                      <i className="ri-close-line"></i>
                    </button>
                  </div>
                </td>
              </tr>
              <tr className="border-t">
                <td className="px-4 py-3">
                  <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-xs">Policy</span>
                </td>
                <td className="px-4 py-3">New vendor onboarding policy</td>
                <td className="px-4 py-3 font-medium">-</td>
                <td className="px-4 py-3">Director</td>
                <td className="px-4 py-3">2024-01-19</td>
                <td className="px-4 py-3">
                  <div className="flex gap-2">
                    <button className="text-green-600 hover:text-green-800 cursor-pointer">
                      <i className="ri-check-line"></i>
                    </button>
                    <button className="text-red-600 hover:text-red-800 cursor-pointer">
                      <i className="ri-close-line"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}